<template>
    <div class="justify-end">
      <div  aria-hidden="true" class="absolute right-0 z-[60] justify-end items-start flex ">
        <div class=" flex flex-col w-fit bg-white border-t rounded-lg border-gray-200 shadow mt-2 h-fit">

          <div class="flex flex-col justify-between mb-4 pt-4 pl-4 pr-4 text-lg font-medium text-gray-900" >
            <div class="flex justify-between ">
              {{ $t('header.addWidget.button.title') }}
              <svg @click="closeSlideOver($event)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 cursor-pointer">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div>
              <input v-model="hideWidgets" type="checkbox" id="hideWidgets">
              <label class="ml-2 text-sm" for="hideWidgets">{{ $t('header.addWidget.button.hide') }}</label>
            </div>
          </div>

          <div class="w-screen sm:w-[32rem]">
            <div class=" pb-4 flex flex-col  ">
              <div class="border-b border-gray-200 w-full ">
                <nav class="pl-6 pb-4 ">
                  <a ref="currentTab" v-for="tab in tabs" :key="tab" @click="changeTab($event.target.innerHTML)"
                     :class="[tab === selectedTabName  ? 'importantText borderColor' : 'cursor-pointer border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', ' whitespace-nowrap pb-4 border-b-2 font-medium text-sm px-4 sm:px-2 ']">
                    {{ tab }}</a>
                </nav>
              </div>
                <div class="w-full">
                  <ul class="w-full h-[30rem] overflow-y-auto">
                    <li v-for="widget in selectedTab" @click="addWidget(widget)" :key="widget" :class="[currWidgets.includes(widget.handle)? 'cursor-not-allowed text-gray-400  ' : 'cursor-pointer  hoverColor' ]">
                      <div :class="(currWidgets.includes(widget.handle)===true) && hideWidgets ? ' ': ' border-b border-gray-200 '">

                        <div v-if="(currWidgets.includes(widget.handle)===false) || (currWidgets.includes(widget.handle) === !hideWidgets)" :class="[currWidgets.includes(widget.name)? ' cursor-not-allowed text-gray-400  ':  ' pb-2  ml-6  hover:border-gray-300 ']">
                          <div class="flex pt-1 flex-row">
                            <div class="mt-2 mr-2">
                              <div v-if="widget.icon === 'TABLE'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-table" viewBox="0 0 16 16">
                                  <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/>
                                </svg>
                              </div>
                              <div v-else-if="widget.icon === 'PIE'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pie-chart" viewBox="0 0 16 16">
                                  <path d="M7.5 1.018a7 7 0 0 0-4.79 11.566L7.5 7.793V1.018zm1 0V7.5h6.482A7.001 7.001 0 0 0 8.5 1.018zM14.982 8.5H8.207l-4.79 4.79A7 7 0 0 0 14.982 8.5zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"/>
                                </svg>

                              </div>
                              <div v-else-if="widget.icon === 'HORIZONTAL_BAR' ">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bar-chart" viewBox="0 0 16 16">
                                  <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>
                                </svg>
                              </div>
                              <div v-else-if="widget.icon === 'LINE'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z"/>
                                </svg>
                              </div>
                            </div>
                            <a v-html="widget.name" ></a>
                          </div>
                          <p class="text-sm text-wrap ">{{widget.info}}</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>

<script setup>
import {defineProps, defineEmits, onMounted, ref} from 'vue'
import ApiService from "@/services/ApiService";
import {useApiStore} from "@/stores/ApiStore";
let apiService = new ApiService;

const apiDataStore = useApiStore();

const props = defineProps ({
  showSlideOver: Boolean,
  currentWidgets: Array,
})

const emit = defineEmits(["closeSlideOver", "addWidget"])


function closeSlideOver(){
  emit("closeSlideOver");
}
let tabs = ref([]);
let allWidgets = ref();
let selectedTab = ref([])
let currentTab = ref(null);
let selectedTabName = ref();
let currWidgets = ref([]);
let hideWidgets = ref(null);
let totalWidth = ref(" w-[32rem] ")
onMounted( async ( ) =>{
  if (screen.width < 625){
    totalWidth.value = " w-screen "
  }
  currWidgets.value = [];
  props.currentWidgets.forEach(entry => {
    currWidgets.value.push(entry.type)
  })
  allWidgets.value = await apiService.getWidgets();

  // allWidgets.value = data.value.widgets;
  getTabs(allWidgets.value);
  widgetsPerTab(tabs.value, allWidgets.value);
  selectedTab.value = tabWidgets.value.get(getAllTranslation(apiDataStore.getLang))
  selectedTabName.value = getAllTranslation(apiDataStore.getLang);
})


function getTabs(widgets){
  tabs.value = [getAllTranslation(apiDataStore.getLang)]
  widgets.forEach(entry => {
    if (! tabs.value.includes( entry.type)){
      tabs.value.push(entry.type)
    }
  })
}

function changeTab(e){
  selectedTabName.value = e;
  selectedTab.value = tabWidgets.value.get(e)
}

let tabWidgets = ref();
function widgetsPerTab(tabs, allWidgets){
  tabWidgets.value = new Map();
  tabs.forEach( entry => {
    let widgets = []
    allWidgets.forEach(widget => {
      if (widget.type === entry || entry === getAllTranslation(apiDataStore.getLang)){
        widgets.push(widget)
      }
    })
    tabWidgets.value.set(entry, widgets);
  })
}

function addWidget(widget){
  if (! currWidgets.value.includes(widget.handle)){
    currWidgets.value.push(widget.handle)
    emit("addWidget", widget);
  }
}

function getAllTranslation(lang) {
  switch (lang) {
    case 'nl':
      return 'Alle';
    case 'de':
      return 'Alle';
    case 'en':
      return 'All';
    case 'fr':
      return 'Tous';
    default:
      return ' ';
  }
}

</script>
